import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const CrossRoad11ARed11BBlack = () => <CrossRoad coords="2262.000000, 449.000000" color={tracksColors.red}/>;
export default CrossRoad11ARed11BBlack;
